<script>
	var moment = require('moment');

	var Pikaday = require('pikaday'),
		originalToString = Pikaday.prototype.toString;

	Pikaday.prototype.toString = function () {
		var string = originalToString.apply(this, arguments),
			now = new Date();

		if (this._d.getYear() === now.getYear() && this._d.getMonth() === now.getMonth() && this._d.getDate() === now.getDate()) {
			string += ' (Today)';
		}

		return string;
	};

	var pickers = [];

	function startAdjustPickerListeners() {
		const adjustAllPositions = () =>
			pickers.forEach(p => {
				p.adjustPosition();
			});

		$(window).on('scroll.pickerAdjust', adjustAllPositions);
		$('.modal').on('scroll.pickerAdjust', adjustAllPositions);
		$('.scroll-box').on('scroll.pickerAdjust', adjustAllPositions);
	}

	function stopAdjustPickerListeners() {
		$(window).off('scroll.pickerAdjust');
		$('.modal').off('scroll.pickerAdjust');
		$('.scroll-box').off('scroll.pickerAdjust');
	}

	module.exports = {
		props: {
			date: {
				type: Number,
				required: false
			},
			minDate: {
				type: Number,
				required: false
			},
			maxDate: {
				type: Number,
				required: false
			},
			onDateSelect: {
				type: Function,
				default: function () {}
			},
			disabled: {
				type: Boolean,
				default: false
			},
			required: {
				default: false
			},
			position: {
				default: 'top'
			},
			inputId: {
				type: String
			}
		},

		mounted() {
			var self = this;

			let defaultDate = new Date();
			let minDate = new Date();
			let maxDate = moment(new Date()).add(12, 'months').toDate();

			if (this.date) {
				defaultDate = new Date(this.date);
			}

			if (this.minDate) {
				minDate = new Date(this.minDate);
			}

			if (this.maxDate) {
				maxDate = new Date(this.maxDate);
			}

			this.picker = new Pikaday({
				field: this.$refs.datepicker,
				format: 'M/D/YYYY',
				defaultDate: defaultDate,
				minDate: minDate,
				maxDate: maxDate,
				setDefaultDate: true,
				position: this.position,
				reposition: true,
				onSelect: function (newDate) {
					const oldValue = self.date;
					const date = newDate.getTime();
					self.$emit('update:date', date);
					if (self.onDateSelect) {
						self.onDateSelect(date, oldValue);
					}
				}
			});

			pickers.push(this.picker);

			if (pickers.length === 1) {
				startAdjustPickerListeners();
			}
		},

		methods: {
			show: function () {
				if (!this.disabled) {
					this.picker.show();
				}
			}
		},

		watch: {
			date: function (value) {
				if (value && this.picker.getDate().getTime() !== value) {
					this.picker.setDate(value ? new Date(value) : new Date());
				}
			},

			minDate: function (value, oldValue) {
				if (value) {
					this.picker.setMinDate(value ? new Date(value) : new Date());
				}
			},

			maxDate: function (value, oldValue) {
				if (value) {
					this.picker.setMaxDate(value ? new Date(value) : new Date());
				}
			}
		},

		beforeDestroy: function () {
			var picker = this.picker;

			if (picker) {
				picker.destroy();

				for (var i = 0, l = pickers.length; i < l; i++) {
					if (pickers[i] === picker) {
						pickers.splice(i, 1);

						break;
					}
				}

				if (!pickers.length) {
					stopAdjustPickerListeners();
				}
			}
		}
	};
</script>
<template>
	<div
		v-on:click="show"
		class="date-picker text-muted">
		<i
			class="fa-regular fa-calendar-days"
			aria-hidden="true"></i>
		<input
			type="text"
			:id="inputId"
			class="date-input padding-small"
			:disabled="disabled"
			:required="required"
			ref="datepicker" />
	</div>
</template>
<style lang="sass">
	@import 'config/colors';

	.date-picker {
		position: relative;

		input,
		input {
			color: $c-slate-dark;
			padding-left: 2rem;
		}

		.fa-calendar-days {
			position: absolute;
			padding: 0.7rem;
		}

	}

	.pika-table {
		th {
			color: $c-slate-dark;
		}

		.is-selected .pika-button {
			background-color: $c-blue-dark;
			color: $c-white;
		}

		.pika-button {
			color: $c-slate-muted;

			&:hover {
				background-color: $c-orange-3;
				color: $c-slate-dark;
			}
		}
	}
</style>
